import React, { useState, useEffect } from "react"
import Layout from "../components/layouts/layoutHome"
import { Container, Row, Col, Button } from "react-bootstrap";
import SEO from "../components/seo";
import { navigate, Link } from "gatsby";
import { globalHistory } from "@reach/router";



import carroNuevo from "../images/nuevo-carro.png";
import btnVendeTuAuto from "../images/Nuevo/Principal/b_vende_nissan.png";
import btnVerSemis from "../images/Nuevo/Principal/b_ver_seminuevos_nissan.png";
import todosSomos from "../images/Nuevo/Principal/todos_primos_nissan.jpg";
import tallerMovil from "../images/Nuevo/Principal/tira_taller_movil_nissan.png";
import btnHacerCita from "../images/Nuevo/Principal/b_cita_nissan.png";
import btnNissan from "../images/Nuevo/Principal/b_nissan.png";


import Image from "../components/widgets/basico/image";

///////////////////// HOME PAGE //////////////////////

const IndexPage = (props) => {
  const parameters = props.location.search;
  const [aleaMovil, setAleaMovil] = useState();

  function navegante(marca) {
    globalHistory.location.pathname.split("");
    navigate(`/${marca.toLowerCase()}/catalogo/nuevos` + parameters, { state: { marcaHome: marca } });
  }

  useEffect(() => {
    const numberBannerMovil = [2];
    var aletatorioMovil = parseInt(Math.random() * (numberBannerMovil.length));
    var aleatorioFondo = `f-movil-${aletatorioMovil}.jpg`;
    setAleaMovil(aleatorioFondo);
  }, []);

  //console.log("Aleatorio de nissan: ", aleaMovil);
  return (
    <Layout parameters={parameters}>
      <SEO
        title="Rivero Nissan Monterrey - Agencia Autos Nuevos y Seminuevos"
        description="Grupo Automotriz - Agencias Nissan Monterrey. Apoyamos a la gente de manera transparente, para que estrenes tu carro nuevo o seminuevo. March, Versa, Sentra, Kicks, Xtrail, Altima"
        keywords="Rivero Nissan, agencia nissan, autos seminuevos, carro nuevo, carro nissan, estrena carro"
      />
      <div className="fullContain">
        <Container fluid className="d-lg-block d-md-block d-none p-0" >
   
          <div className="d-lg-flex d-md-flex d-none" style={{ position: "relative" }} >
              <div  style={{height: '100%', width: '100%' }}>
                  <Image
                      fileName={`back-sentra.jpg`}
                      alt="galeria video silverado"
                      imgStyles={{ width: "100vw", height: "100vh" }}
                      style={{ width: "100vw", height: "100vh" }}
              /> 
              </div>
            <div style={{position: 'absolute', paddingTop: 150, zIndex: 1, width:'100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
              <Container className="p-0">
                <div style={{height: 75}}>
                  <Image
                      fileName={`todos_primos_nissan`}
                      alt="seminuevos"
                      imgStyles={{ width: "50%", height: 75, objectFit: 'contain'}}
                      style={{ width: "50%", height: 75 }}
                  />
                </div>
              </Container>
              <Container >
               {<Row>
                  <Col lg={5} md={5} sm={5} xs={5}>
                  </Col>
                  <Col style={{marginTop: '2em'}} lg={3} md={3} sm={3} xs={3}>
                    <Col  lg={12} md={12} sm={12} xs={12} className="dosBoton2">
                      <center>
                        <div className="nuevoCarro" style={{ height: 100 }}>
                          <Image
                            fileName={`nuevo-carro.png`}
                            alt="letras carro nuevo"
                            imgStyles={{ width: "100%", height: "100%", objectFit: 'contain' }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </div>
                      </center>
                    </Col>
                  </Col>
                  <Col style={{marginTop: '2em'}} lg={4} md={4} sm={4} xs={4}>
                    <div className="banner-container-botones">
                      <center>
                        <div id="btnNissanHome"
                          className="btn-nissan-home pt-3 pb-3"
                          onClick={() => navegante("NISSAN")} >
                          <img className="btnNissanIndex" src={btnNissan} />
                        </div>
                      </center>
                    </div>
                  </Col>
                </Row>}
                <Row className="d-lg-flex d-md-flex d-none mt-5 mb-5">
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="banner-container-nissan-seminuevos d-md-flex">
                      <center>
                        <Link id="btnVerAutos" to={"/catalogo/seminuevos/" + parameters}>
                          <img className="btnsSemis"
                            style={{
                              height: "22px",
                              
                              marginBottom: "5px",
                              cursor: "pointer",
                            }}
                            src={btnVerSemis}
                          />
                        </Link>
                        <br />
                        <Link id="btnVendeTuAuto" to={"/valua-tu-carro/" + parameters}>
                          {" "}
                          <img className="btnsSemis"
                            style={{ height: "22px",  cursor: "pointer" }}
                            src={btnVendeTuAuto}
                          />{" "}
                        </Link>
                      </center>
                    </div>
                  </Col>

                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="banner-container-nissan-taller">
                      <Link id="btnHacerCitaHome" to={"/taller-de-servicio/" + parameters}>
                        <center>
                          <img
                            style={{
                              height: "22px",
                              marginBottom: "5px",
                              visibility: "hidden",
                            }}
                            src={btnVerSemis}
                          />
                          <br />
                          <img
                            style={{
                              height: "22px",
                              cursor: "pointer",
                              visibility: "hidden",
                            }}
                            src={btnVendeTuAuto}
                          />
                        </center>
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Container>
        

        <Container className="d-lg-none d-md-none d-flex px-0">
          <div className="container-zoom-movil">
            <div class="zoom-in-zoom-out">
              <Image
                fileName={`${aleaMovil}`}
                alt="banner Image Home"
                style={{ height: '100%' }}
              />
            </div>
          </div>
          <Container style={{ width: '100%', position: 'absolute' }}>
            <img className="todosSomos pt-4" src={todosSomos} />

            <Row className="justify-content-end">
              <Col lg={6} md={6} sm={6} xs={12} className="quieresNuevoMovil">
                <img className="carroNuevoMovil" src={carroNuevo} />
              </Col>
              <Col lg={6} md={6} sm={6} xs={12} style={{marginTop:"10px"}}>
                <div>
                    <div id="btnIrNissanMovil"
                      className="btn-nissan-index-smovil"
                      onClick={() => navegante("NISSAN")}
                    >
                      <img className="btnNissanIndex" src={btnNissan} />
                    </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>

        <Container className="d-lg-none d-md-none d-block dosTiras">
          <Row className="p-3 div-tira-seminuevos-nissan">
            <Col className="d-flex align-items-center p-0" lg={6} md={6} sm={6} xs={6} >
              <div className="tira-seminuevos-movil">
                <div className="semisMovil">
                  <Image
                    fileName="tira_seminuevos_movil.png"
                    alt="Banner Seminuevos"
                  />
                </div>
              </div>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <center>
                <div className="tira-seminuevos-movil">
                  <Link id="btnVerAutosMovil" to={"/catalogo/seminuevos/" + parameters}>
                    <div className="btn-tira-movil m-1">
                      <Image
                        fileName="b_ver_seminuevos_nissan.png"
                        alt="Banner Seminuevos"
                      />
                    </div>
                  </Link>
                  <Link id="btnVendeTuAutoMovil" to={"/valua-tu-carro/" + parameters}>
                    <div className="btn-tira-movil m-1">
                      <Image
                        fileName="b_vende_nissan.png"
                        alt="Banner Seminuevos"
                      />
                    </div>
                  </Link>
                </div>
              </center>
            </Col>
          </Row>
          <Row className="p-3 div-tira-taller-nissan">
            <Col className="d-flex align-items-center p-0" lg={6} md={6} sm={6} xs={6} >
              <div id="btnHacerCitaMovil" className="tira-taller-movil">
                <img className="tallerMovil" src={tallerMovil} />
              </div>
            </Col>

            <Col className="d-flex justify-content-center align-items-center" lg={6} md={6} sm={6} xs={6} >
              <div id="btnHacerCita" className="tira-taller-movil">
                <Link to={"/taller-de-servicio/" + parameters}>
                  <img className="btn-tira-movil m-1" src={btnHacerCita} />
                </Link>
              </div>
            </Col>
          </Row>

        </Container>
      </div>
    </Layout>
  );
}

export default IndexPage
